import {Injectable} from '@angular/core';
import {DcpDataService} from '../dcp-data.service';
import {CxEvent, EventService, User} from '@spartacus/core';
import {EddlAdobeTrackingData} from './models/eddl-adobe-tracking-data';
import {combineLatest, Observable} from 'rxjs';
import {DcpAuthService} from '../../../auth/services/dcp-auth.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {debounceTime, filter, first, map} from 'rxjs/operators';
import {EddlInitializationEvent} from './events/eddl-initialization-event';
import {EddlAfterInitializationEvent} from './events/eddl-after-initialization-event';
import {UserAccountFacade} from '@spartacus/user/account/root';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class DcpEddlGlobalDataLayerService extends DcpDataService<EddlAdobeTrackingData> {
  constructor(
    protected authService: DcpAuthService,
    protected eventService: EventService,
    protected userFacade: UserAccountFacade
  ) {
    super();
  }

  fillData(
    event: EddlInitializationEvent,
    data?: EddlAdobeTrackingData,
    isLoggedIn?: boolean,
    user?: User
  ): EddlAdobeTrackingData {
    if (!data) {
      data = {};
    }
    data.event = 'globalDL';
    data.site = {
      name: 'sapapp',
      country: 'glo', // DCP-51308: hardcoded as we don't offer country specific sites at the moment
    };
    data.user = {
      loginStatus: isLoggedIn ? 'yes' : 'no',
      scimUserId: isLoggedIn && user?.scimUserId ? user.scimUserId : '',
    };
    return data;
  }

  getData(event: CxEvent): EddlAdobeTrackingData | Observable<EddlAdobeTrackingData> {
    if (!(event instanceof EddlInitializationEvent)) {
      return undefined;
    }
    return combineLatest([this.authService.isUserLoggedIn(), this.userFacade.get()]).pipe(
      filter(([isLoggedIn, user]) => isLoggedIn === !!user),
      debounceTime(400),
      first(),
      untilDestroyed(this),
      map(([isLoggedIn, user]) => {
        setTimeout(() => {
          this.eventService.dispatch(new EddlAfterInitializationEvent());
        });
        return this.fillData(event, undefined, isLoggedIn, user);
      })
    );
  }
}
